import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';
import { Label } from '@hivebrite/design-system/Label';

import { usePaymentContext } from 'hb-react/shared/components/Payment/context/PaymentContext';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const SplitedCardFields = () => {
  const { setFieldError, errors } = useFormikContext();
  const { setCardNetwork, preferredCardNetworks } = usePaymentContext();
  const { flagEvStripeCobrandedCards } = useFeatureFlag();

  const onChange = (element) => {
    setFieldError(element.elementType, element.error?.message);
  };

  const onNetworksChange = (event) => {
    setCardNetwork(event.networks);
  };

  return (
    <Wrapper>
      <Box flexDirection="column" mb={3} data-testid="card-number">
        <Label id="stripe-card-number" required>
          {s__('Stripe|Card number')}
        </Label>
        {flagEvStripeCobrandedCards ? (
          <CardNumberElement
            options={{
              showIcon: true,
              preferredNetwork: preferredCardNetworks,
            }}
            id="stripe-card-number"
            onNetworksChange={onNetworksChange}
            onChange={onChange}
          />
        ) : (
          <CardNumberElement id="stripe-card-number" onChange={onChange} />
        )}

        {errors.cardNumber && (
          <AdditionalInformation type="error" id="stripe-card-number">
            {errors.cardNumber}
          </AdditionalInformation>
        )}
      </Box>
      <Box flexDirection="column" with="100%" mb={3} data-testid="card-expiry">
        <Label id="stripe-card-expiry" required>
          {s__('Stripe|Expiration date')}
        </Label>
        <CardExpiryElement id="stripe-card-expiry" onChange={onChange} />
        {errors.cardExpiry && (
          <AdditionalInformation type="error" id="stripe-card-expiry">
            {errors.cardExpiry}
          </AdditionalInformation>
        )}
      </Box>
      <Box flexDirection="column" with="100%" mb={3} data-testid="card-cvc">
        <Label id="stripe-card-cvc" required>
          {s__('Stripe|CVC')}
        </Label>
        <CardCvcElement id="stripe-card-cvc" onChange={onChange} />
        {errors.cardCvc && (
          <AdditionalInformation type="error" id="stripe-card-cvc">
            {errors.cardCvc}
          </AdditionalInformation>
        )}
      </Box>
    </Wrapper>
  );
};

export default SplitedCardFields;

const Wrapper = styled(Box)`
  flex-direction: column;
  row-gap: 12px;
`;
